import { useState, useEffect } from 'react';

const MAPS_API_KEY = 'AIzaSyAxxkGHlnAKnGQz_KYJdg8Ztd8PhrF6S7U';

export function useGoogleMapsLoader() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoadingScript, setIsLoadingScript] = useState(false);

  useEffect(() => {
    if (window.google?.maps?.places) {
      setIsLoaded(true);
      return;
    }

    const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => setIsLoaded(true));
      return;
    }

    setIsLoadingScript(true);
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => { setIsLoaded(true); setIsLoadingScript(false); };
    script.onerror = () => { console.error('Failed to load Google Maps API'); setIsLoadingScript(false); };
    document.head.appendChild(script);
  }, []);

  return { isLoaded, isLoadingScript };
}
